export default "__VITE_ASSET__XQl1bKf5__"